export function sumByKey<T>(items: T[], key: keyof T) {
  return items.reduce((acc, item) => {
    const aggregateKey = item[key]

    if (typeof aggregateKey !== 'string') return acc

    if (acc[aggregateKey] === undefined) {
      acc[aggregateKey] = 1
    } else {
      acc[aggregateKey] += 1
    }

    return acc
  }, {} as Record<string, number>)
}
